import { getPaymentListFormats } from '@/api/payment'

export default {
  async fetchPaymentList ({ commit }) {
    try {
      const data = await getPaymentListFormats()
      commit('SET_PAYMENT_LIST', data)
      return data
    } catch (err) {
      console.error('Failed to fetch payment list:', err)
      // เก็บ default ว่างไว้ ถ้า API ยังไม่มี
      commit('SET_PAYMENT_LIST', {
        bankOptions: [],
        navItems: [],
        filterItems: [],
        paymentMethods: []
      })
    }
  }
}
